import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close_5bd64480599479d4dd9706a4332c6969",
  "use": "close_5bd64480599479d4dd9706a4332c6969-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"close_5bd64480599479d4dd9706a4332c6969\">\n    <path fill-rule=\"evenodd\" d=\"M8.25 7.19l4.72-4.72 1.06 1.06-4.72 4.72 4.72 4.72-1.06 1.06-4.72-4.72-4.72 4.72-1.06-1.06 4.72-4.72-4.72-4.72 1.06-1.06z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol